import { shipmentCommentUploadValidate } from "../../../shipment_comments/application/dtos/shipment_comment_upload_validate";

export class shipmentCommentEntity {
    constructor({ id, date, comments, category, model, record_id }){
        this.id = id;
        this.date = date;
        this.comments = comments;
        this.category = category;
        this.model = model;
        this.record_id = record_id;
    }

    isValid() {
        return shipmentCommentUploadValidate(this);
    }
}